/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/views/web/product/List/List.tsx
 * @Description: PC端商品列表视图组件
 */
import { Spin } from 'antd';
import Container from 'comps/Container';
import ListFilter from 'comps/ListFilter';
import ListRuleBar, { SorterOrder } from 'comps/ListRuleBar';
import ListSearchResult from 'comps/ListSearchResult';
import SearchListContent from 'comps/SearchListContent';
import SideBar from 'comps/SideBar';
import { useContext, useState, useMemo, useEffect } from 'react';
import { SiteContext, UserContext } from 'libs/contexts';
import { useRouter } from 'next/router';
import Layout from 'comps/Layout';
import Footer from 'comps/Footer';
import Header from 'comps/Header';
import jsurl from 'jsurl';
import { apiGetProductList, apiGetManufacturerSupplyAgreement } from 'api/mall';
import { useGtZeroEffect } from 'hooks/useGtZeroEffect';
import { useNetActionPriceContext } from 'libs/contexts';
import AgreementSelector from '@/biz-components/web/AgreementSelector';
import ContractSelector from '@/biz-components/web/ContractSelector';
import { UserSource } from 'libs/enums';
import { convertUrlParam2Obj } from './helper';

export default function ProductListView({ productListData }) {
  const userInfo = useContext(UserContext);
  const router = useRouter();
  const site = useContext(SiteContext);
  const getNetPriceList = useNetActionPriceContext();
  const primaryColor = site.global?.platformMainColor;
  const buildFilterList = (data) => {
    return [
      data.upstreamSupplierList?.lenth && {
        type: 'upstreamSupplierSysNoList',
        name: '配送商',
        values: data.upstreamSupplierList.map((v) => ({
          ...v,
          val: [
            {
              type: 'upstreamSupplierSysNoList',
              sysNo: v.sysNo,
              name: v.name,
            },
          ],
        })),
      },
      data.brandList?.length && {
        type: 'brands',
        name: '品牌',
        values: data.brandList.map((v) => ({
          ...v,
          val: [
            {
              type: 'brands',
              sysNo: v.sysNo,
              name: v.name,
            },
          ],
        })),
      },
      ...(data.spuAttributeList?.length
        ? data.spuAttributeList.map((v) => ({
            type: 'spuAttributeList',
            name: v.name,
            values: v.values.map((e) => ({
              ...e,
              val: [
                {
                  type: 'spuAttributeList',
                  sysNo: e.sysNo,
                  name: e.name,
                },
              ],
            })),
          }))
        : []),
    ].filter(Boolean);
  };
  const [loading, setLoading] = useState(false); // 控制加载状态
  const [listData, setListData] = useState(productListData.spuList); // 房屋列表数据
  const [areaLevelCode, setAreaLevelCode] = useState('');
  const [upstreamSupplierSysNoList, setUpstreamSupplierSysNoList] = useState([]);
  const listDataPageSize = useMemo(() => {
    return {
      ...listData,
      // datas: listData?.datas?.slice(
      //   (listData.pageNo - 1) * listData.pageSize,
      //   listData.pageNo * listData.pageSize,
      // ),
    };
  }, [listData]);
  const [filterList, setFilterList] = useState(buildFilterList(productListData)); // 过滤列表
  const updateSearch = (updateParams, isRequest = false) => {
    if (updateParams.areaLevelCode) {
      updateParams.agreementSysNoList = [];
      updateParams.contractAgreementSysNoList = [];
      setAreaLevelCode(updateParams.areaLevelCode);
    }
    if (updateParams.upstreamSupplierSysNoList) {
      updateParams.agreementSysNoList = [];
      updateParams.contractAgreementSysNoList = [];
      setUpstreamSupplierSysNoList(updateParams.upstreamSupplierSysNoList);
    }
    // const { query } = router;
    const query = convertUrlParam2Obj(location.href);
    // if ((updateParams.pageNo || updateParams.pageSize || updateParams.showType) && !isRequest) {
    if (updateParams.showType && !isRequest) {
      setLoading(true);
    }
    if (!updateParams.pageNo || isRequest) {
      updateParams.pageNo = 1;
    }

    const newQuery = {
      ...query,
      params: jsurl.stringify({ ...(jsurl.parse(query.params) || {}), ...updateParams }),
    };
    const url = {
      pathname: router.pathname,
      query: newQuery,
    };

    const queryStr = Object.entries(newQuery)
      .map((item) => item.join('='))
      .join('&');

    const urlStr = url.pathname + '?' + queryStr;
    router.push(url, urlStr, {
      shallow: true,
    });
  };

  const getList = async () => {
    try {
      const params = jsurl.parse(router.query.params) || {};
      let agreementList = null;
      if (loading) {
        setListData({
          ...listData,
          pageNo: params.pageNo || listData.pageNo,
          pageSize: params.pageSize || listData.pageSize,
        });
        setLoading(false);
        return;
      }
      setLoading(true);
      if (router.query.supplierId) {
        // 厂家直供商品列表
        const result = await apiGetManufacturerSupplyAgreement({
          query: {
            supplierSysNo: router.query.supplierId,
          },
        });
        agreementList = result?.data || [];
      }
      let attributeNames = '';
      let attributeValues = '';
      params.spuAttributeList?.forEach((v: { name: 'string'; values: any }) => {
        const arr = v.values?.map(() => v.name) || [];
        const valArr = v.values?.map((val) => val.name || val) || [];
        attributeNames += arr.join(',');
        attributeValues += valArr.join(',');
      });
      const brandSysNoList = params?.brands?.map((v) => v.sysNo);
      params.upstreamSupplierSysNoList = Array.isArray(params.upstreamSupplierSysNoList)
        ? params.upstreamSupplierSysNoList.join(',')
        : params.upstreamSupplierSysNoList;
      const { data } = await apiGetProductList({
        json: {
          greenType: params.greenType || router.query.greenType,
          selefBrandType: params.selefBrandType || router.query.selefBrandType,
          catId: params.catId || router.query.catId,
          key: router.query.key || params.keyword,
          minPrice: params.priceRangeLow,
          maxPrice: params.priceRangeHigh,
          sortField: params.sorts?.length ? params.sorts[0].sortField : 'totalScore',
          orderBy: params.sorts?.length ? params.sorts[0].orderBy : SorterOrder.DESC,
          attributeNames,
          attributeValues,
          brandIds: brandSysNoList?.join(','),
          brandSysNoList,
          supplyFlag: !!router.query.supplierId, // 是否是厂家直采
          agreementList,
          shopSysNo: router.query.shopId || null,
          ...params,
        },
      });
      if (data?.spuList?.pageSize === 600) {
        data.spuList.pageSize = params.pageSize || 30;
      }
      setListData(data.spuList);
      setFilterList(buildFilterList(data));
      getNetPriceList(data.spuList?.datas, (list) => {
        setListData({
          ...data.spuList,
          datas: list,
        });
      });
    } catch (error) {}
    setLoading(false);
  };
  useEffect(() => {
    getNetPriceList(productListData.spuList?.datas, (list) => {
      setListData({
        ...productListData.spuList,
        datas: list,
      });
    });
  }, []);
  useGtZeroEffect(() => {
    getList();
  }, [router]);
  return (
    <Layout
      header={<Header showAreaCascader={false} />}
      footer={<Footer />}
      keywords="数字化,供应链管理,数字采购,供应链金融"
      description={`${
        site?.basic?.tenantName || ''
      }通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效`}
      showFixedMenu
      bgColor="#ffffff"
    >
      <div className="product-list">
        {loading && (
          <div className="loading-wrap">
            <Spin />
          </div>
        )}
        <Container>
          <ListSearchResult
            shopCustomCategoryList={null}
            primaryColor={primaryColor}
            keywords={router.query.key as string}
            total={listDataPageSize.total}
            isToProductList
          />
          <ListFilter
            primaryColor={primaryColor}
            filterList={filterList}
            updateSearch={(param) => {
              updateSearch(param, true);
            }}
          />
          <ListRuleBar
            primaryColor={primaryColor}
            listData={listDataPageSize}
            updateSearch={updateSearch}
            defaultSorter="totalScore"
            defaultOrderBy={SorterOrder.DESC}
          >
            {userInfo?.organizationSource === UserSource.inside && (
              <>
                <AgreementSelector
                  updateSearch={updateSearch}
                  areaLevelCode={areaLevelCode}
                  supplierSysNoList={upstreamSupplierSysNoList}
                />
                <ContractSelector
                  updateSearch={updateSearch}
                  areaLevelCode={areaLevelCode}
                  supplierSysNoList={upstreamSupplierSysNoList}
                />
              </>
            )}
          </ListRuleBar>
          <SearchListContent listData={listDataPageSize} updateSearch={updateSearch} />
          {!!userInfo?.isPurchaser && <SideBar />}
        </Container>
        <style jsx>
          {`
          .loading-wrap {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 9999;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .product-list {
            background-color: #fff;
          }
          :global(.container) {
            position: relative;
          }
          :global(.rule-bar .sort-list .all, .rule-bar .sort-list .salesPrice) {
            display: none;
          }
        `}
        </style>
      </div>
    </Layout>
  );
}
